
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'IconBack',
  props: {
    width: {
      type: [String, Number] as PropType<string | number>,
      default: 24
    },
    height: {
      type: [String, Number] as PropType<string | number>,
      default: 24
    },
    color: {
      type: String,
      default: '#A2A5BB'
    }
  }
})
